export default {
  "wt-select": "_wt-select_1jdrsx3_7",
  "wt-select_disabled": "_wt-select_disabled_1jdrsx3_36",
  "wt-select_error": "_wt-select_error_1jdrsx3_45",
  "wt-select_theme_light": "_wt-select_theme_light_1jdrsx3_53",
  "wt-select_searchFocused": "_wt-select_searchFocused_1jdrsx3_53",
  "wt-select_theme_dark": "_wt-select_theme_dark_1jdrsx3_54",
  "wt-select_open": "_wt-select_open_1jdrsx3_55",
  "wt-select_size_m": "_wt-select_size_m_1jdrsx3_66",
  "wt-select__label-wrapper": "_wt-select__label-wrapper_1jdrsx3_79",
  "wt-select_size_s": "_wt-select_size_s_1jdrsx3_83",
  "wt-select_size_xs": "_wt-select_size_xs_1jdrsx3_100",
  "wt-select__icons-wrapper": "_wt-select__icons-wrapper_1jdrsx3_113",
  "wt-select_isMulti": "_wt-select_isMulti_1jdrsx3_135",
  "wt-select__label_notSelected": "_wt-select__label_notSelected_1jdrsx3_155",
  "wt-select__toggle": "_wt-select__toggle_1jdrsx3_176",
  "wt-select__label": "_wt-select__label_1jdrsx3_79",
  "wt-select__search-input": "_wt-select__search-input_1jdrsx3_295",
  "wt-select__multi": "_wt-select__multi_1jdrsx3_313",
  "wt-select__tag": "_wt-select__tag_1jdrsx3_339",
  "wt-select__icon": "_wt-select__icon_1jdrsx3_113",
  "wt-select__toggle_open": "_wt-select__toggle_open_1jdrsx3_366",
  "wt-select__icon_open": "_wt-select__icon_open_1jdrsx3_366",
  "wt-select__icon_size_m": "_wt-select__icon_size_m_1jdrsx3_387",
  "wt-select__icon_size_s": "_wt-select__icon_size_s_1jdrsx3_391",
  "wt-select__icon_size_xs": "_wt-select__icon_size_xs_1jdrsx3_395"
};